import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Invite } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Invite>>>;

const getInvitesForOrganization = (id: string): ReturnType => {
    return Request.get(`/organizations/${id}/invites`);
};

export default getInvitesForOrganization;
